import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/calm/github/web/apps/www/src/components/layout/DesignSystemProvider/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/calm/github/web/apps/www/src/css/fonts.css");
